import { Page } from "components/common/layout"
import { navBarSections } from "extensions/utils/Classes"
import PropTypes from "prop-types"
import React from "react"
import { FaBan } from "react-icons/fa"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useAllowedPaths } from "utils"

export default function RouteGuard({
  children,
  enableForAllProjects,
  portalComponentKey,
  sectionName
}) {
  const location = useLocation()
  const allowedPaths = useAllowedPaths()
  const allowedPortalComponents = useSelector(
    (state) => state.user.allowedPortalComponents
  )
  if (
    allowedPaths.includes(location.pathname) &&
    (enableForAllProjects ||
      sectionName !== navBarSections.clientSection ||
      allowedPortalComponents[portalComponentKey])
  ) {
    return children
  }
  return (
    <Page>
      <p className="h1 text-danger text-center">
        <FaBan />
      </p>
      <h1 className="text-danger text-center">Unauthorized</h1>
      <hr />
      <p className="text-danger text-center">
        User does not have access to this view.
      </p>
    </Page>
  )
}

RouteGuard.propTypes = {
  children: PropTypes.node,
  enableForAllProjects: PropTypes.bool,
  portalComponentKey: PropTypes.string,
  sectionName: PropTypes.string
}
